import { Component, OnInit } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import * as Sentry from '@sentry/angular';
import { AuthlessLandingpageService } from './services/authless-landingpage.service';
import { Router } from '@angular/router';
import { SsoUserDto } from './dto/sso-user.dto';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})
export class AppComponent implements OnInit {

  error = '';
  redirectUrl = '';
  userData: SsoUserDto | undefined;
  authenticated = false;

  constructor(
    public oidcSecurityService: OidcSecurityService,
    private authlessLandingpageService: AuthlessLandingpageService,
    private router: Router
  ) {
    this.redirectUrl = window.location.toString();
  }


  ngOnInit(): void {

    if (this.redirectUrl.includes('unauthorized')) {
      return;
    }

    this.oidcSecurityService.checkAuth(this.redirectUrl).subscribe({
      next: (loginResponse) => {
        console.log('EFS Login');
        console.log('Config-ID: ', loginResponse.configId);
        console.log('Error Message: ', loginResponse.errorMessage);
        console.log('IsAuthenticated: ', loginResponse.isAuthenticated);

        if (!loginResponse.isAuthenticated && loginResponse.errorMessage === undefined) {
          sessionStorage.clear();
          this.oidcSecurityService.logoffAndRevokeTokens();
          this.oidcSecurityService.authorize();
        }

        if (loginResponse.errorMessage && loginResponse.errorMessage.includes('authorizedCallback, token(s) validation failed, resetting')) {
          window.location.href = '/unauthorized';
          return;
        }

        this.authenticated = loginResponse.isAuthenticated;

        if (loginResponse.userData) {
          this.userData = loginResponse.userData;

          Sentry.setUser({
            username: this.userData!.preferred_username,
          })
        }
      },
      error: (error) => {
        console.error('Error checking auth: ', error);
        sessionStorage.clear();
        this.oidcSecurityService.logoffAndRevokeTokens();
        this.oidcSecurityService.authorize();
      },
    })
  }


  reloadPage() {
    window.location.reload();
  }
}
